// extracted by mini-css-extract-plugin
module.exports = {"Profile":"Styles_Profile__2ngxW","Form":"Styles_Form__1OZFf","Buttons":"Styles_Buttons__qi-3X","red":"Styles_red__Ac3nH"};